(() => {
  const sticky = document.querySelector('[data-eye-ad-sticky]');
  const nativeButton = document.querySelector('.eye-ad-product .product-form__submit');
  const trigger = document.querySelector('[data-eye-ad-sticky-trigger]');
  const heroTrigger = document.querySelector('[data-eye-ad-hero-trigger]');

  if (!sticky || !nativeButton || !trigger) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const syncStickyVisibility = () => {
    sticky.hidden = !mobileQuery.matches;
  };

  syncStickyVisibility();
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', syncStickyVisibility);
  } else {
    mobileQuery.addListener(syncStickyVisibility);
  }

  const submitNativeForm = () => {
    if (nativeButton.disabled) return;
    nativeButton.click();
  };

  trigger.addEventListener('click', submitNativeForm);
  if (heroTrigger) {
    heroTrigger.addEventListener('click', submitNativeForm);
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      sticky.classList.toggle('is-native-visible', entries[0].isIntersecting);
    }, { threshold: 0.25 });

    observer.observe(nativeButton);
  }
})();
